exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message_area[data-v-6375bfd4] {\n  padding: 15px;\n  border: 2px solid #eee;\n  text-align: center;\n}\n.next[data-v-6375bfd4] {\n  margin-top: 40px;\n  text-align: center;\n}\n.next .el-button[data-v-6375bfd4] {\n  border-radius: 0;\n  padding-left: 30px;\n  padding-right: 30px;\n}", ""]);

// exports
